import {isDevMode, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BodyComponent} from './components/body/body.component';
import {HeaderComponent} from './components/body/components/header/header.component';
import {FooterComponent} from './components/body/components/footer/footer.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {CoreStoreModule} from "@core/store/core-store.module";
import {NgxSpinnerModule} from "ngx-spinner";
import {DBConfig, NgxIndexedDBModule} from 'ngx-indexed-db';
import {INDEXED_DB_KEY} from "@shared/constants/shared.constants";
import {AuthService} from "@core/services/auth.service";
import {NgxSmartModalModule} from "ngx-smart-modal";
import {ToastrModule} from "ngx-toastr";
import {LoadingInterceptor} from "@core/interceptors/loading.interceptor";
import {AuthInterceptor} from "@core/interceptors/auth.interceptor";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {RouterModule} from "@angular/router";
import {Revisione53Service} from "../features/revisione53/core/revisione53.service";
import {Revisione53CoreModule} from "../features/revisione53/core/revisione53-core.module";

const dbConfig: DBConfig  = {
  name: 'ConfCooperative',
  version: 1,
  objectStoresMeta: [{
    store: INDEXED_DB_KEY,
    storeConfig: { keyPath: 'id', autoIncrement: false },
    storeSchema: [
      { name: 'file', keypath: 'file', options: { unique: false } },
    ]
  }]
};


@NgModule({
    declarations: [BodyComponent, HeaderComponent, FooterComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        HttpClientModule,
        RouterModule,
        CoreStoreModule,
        NgbModule,
        NgxSpinnerModule,
        NgxIndexedDBModule.forRoot(dbConfig),
        NgxSmartModalModule.forRoot(),
        ToastrModule.forRoot({
            preventDuplicates: true,
            timeOut: 1500,
        }),
        // Revisione49CoreModule, // import provvisorio. Rivedere struttura moduli. Necessario un provider per Revisione49Service
        Revisione53CoreModule,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        AuthService,
    ],
    exports: [BodyComponent, HeaderComponent, FooterComponent],
})
export class CoreModule {
    public constructor() {}
}
